import styled from 'styled-components';

export const Container = styled.div`
  h1{
    font-size: 3.5em;
  }

  p{
    margin-bottom: 2em;
    color: #ecfa00;
  }
`;
